import { Link } from "react-router-dom";
import type { Actor } from "@/mocks/actors";

interface ActorCardProps {
  actor: Actor;
  compact?: boolean;
}

export default function ActorCard({ actor, compact = false }: ActorCardProps) {
  return (
    <Link
      to={`/detail/actor/${actor.id}`}
      className={`group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300 ${
        compact ? "w-40 shrink-0" : ""
      }`}
    >
      <div className="relative w-full aspect-square overflow-hidden bg-background-200">
        <img
          src={actor.avatar}
          alt={`演员 ${actor.name} 饰演 ${actor.role}`}
          title={`年轻的母亲1 演员 ${actor.name}`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-full bg-primary-950/80 px-2 py-0.5 text-[11px] text-background-50">
          {actor.roleType}
        </span>
      </div>
      <div className="p-3 text-center">
        <h3 className="text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
          {actor.name}
        </h3>
        <p className="mt-0.5 text-xs text-foreground-500">饰 {actor.role}</p>
      </div>
    </Link>
  );
}